import { WidgetProps } from '@features/dashboard/types';
import { useApi } from '@hooks/useApi';
import Widget, { Header } from '../Widget';
import Settings from '../settings/Settings';
import { NewsList } from './NewsList';
import { NewsWidgetPayload } from './newsTypes';
import { useWidgetLifecycleTelemetry } from '../useWidgetLifecycleTelemetry';

type NewsProps = WidgetProps & {
  payload?: NewsWidgetPayload;
  isFrozen?: boolean;
};

export const NewsWidget = ({ payload, ...otherProps }: NewsProps) => {
  const { id, title, isFrozen } = otherProps;
  const { apiClient } = useApi();
  const newsDataLoader = apiClient?.newsLoader();
  useWidgetLifecycleTelemetry(id, title, 'NewsWidget', payload);

  if (!newsDataLoader) return null;

  return (
    <Widget {...otherProps}>
      <Header title={title}>
        <Settings id={`trading-settings-${id}`} title={title} widgetId={id} />
      </Header>
      <NewsList dataLoader={newsDataLoader} isFrozen={isFrozen} />
    </Widget>
  );
};
